import React from 'react';
import { logout } from '../../utility/user_functions';

class LogoutButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button
                onClick={logout}
            >Logout</button>
        )
    }
}

export default LogoutButton;
